<label [for]="label" class="esf-form-item__label">{{ label }}
  <app-optional *ngIf="optional"></app-optional>
</label>
<div class="esf-form-item__field-wrapper" controlErrorContainer>
  <input class="esf-form-item__field"
         [type]="enableTime ? 'datetime-local' : 'date'"
         [name]="label"
         [id]="id"
         [max]="(maxDate)"
         [min]="(minDate)"
         [placeholder]="placeholder"
         [formControl]="formControl">
</div>
